import {uuid} from 'vue-uuid'

function getParameterCaseInsensitive(object, key) {
  return object[Object.keys(object).find((k) => k.toLowerCase() === key.toLowerCase())]
}

export const state = () => ({
  documentos: [],
  verGestorDocumental: false,
  adjuntarEvidencia: false,
  external_ref: null,
  documentos_custom: [],
  addDocumentosModuloExterno: false,
  actualizarEvidencias: false,
  documentos_modulo_externo: [],
})

export const mutations = {
  SET_DOCUMENTOS(state, docs) {
    state.documentos = docs
  },
  SET_DOCUMENTOS_MODULO_EXTERNO(state, docs) {
    /*docs.forEach((d) => {
      state.documentos_modulo_externo.push(d)
    })*/
    state.documentos_modulo_externo = docs
  },
  ADJUNTAR_EVIDENCIA(state, flag) {
    state.adjuntarEvidencia = flag
  },
  ACTUALIZAR_EVIDENCIAS(state, flag) {
    state.actualizarEvidencias = flag
  },
  SET_EXTERNAL_REF(state, ref) {
    state.external_ref = ref
  },
  ADD_CUSTOM(state, data) {
    const body = {
      uuid: data.uuid || uuid.v4(),
      createdAt: new Date(),
      file: data.documento.file,
      mimeType: data.documento.file.type,
      nombreArchivo: data.documento.titulo,
      titulo: data.documento.titulo,
      modulo: data.modulo,
      moduloRef: data.moduloRef,
      submodulo: data.submodulo,
      submoduloRef: data.submoduloRef,
    }
    state.documentos_custom.push(body)
  },
  DELETE_CUSTOM(state, params_uuid) {
    let index = null
    for (let i = 0; i < state.documentos_custom.length; i++) {
      const documento = state.documentos_custom[i]
      if (documento.uuid === params_uuid) index = i
    }
    state.documentos_custom.splice(index, 1)
  },
  INIT_CUSTOM(state) {
    state.documentos_custom = []
  },
  ADD_DOCUMENTOS_MODULO_EXTERNO(state, flag) {
    state.addDocumentosModuloExterno = flag
  },
  RESET_DOCUMENTOS_MODULO_EXTERNO(state) {
    state.documentos_modulo_externo = []
  },
}

export const getters = {
  documentos(state) {
    const documentos = state.documentos
    const documentos_modulo_externo = state.documentos_modulo_externo

    return documentos.concat ? documentos.concat(documentos_modulo_externo) : []
  },
  documentos_modulo_externo(state) {
    return state.documentos_modulo_externo
  },
}

//dispatch actions
export const actions = {
  async list({ state, commit }, route) {
    let params = {}

    if (route.name.indexOf('uuid') !== -1) {
      let path = route.path.split('/')
      let modulo = path[1]
      let moduloRef = path[2]
      // TODO DESARROLLO: MEJORAR LAS RUTAS DE AUDITORIA PARA PODER MANTENER ESTO DINAMICO
      if (moduloRef === 'tabs') {
        const modulo_uuid = route.fullPath.split('uuid=')
        moduloRef = modulo_uuid[1]
      }
      // TODO DESARROLLO: MEJORAR LAS RUTAS DE AUDITORIA PARA PODER MANTENER ESTO DINAMICO
      let submodulo = ''
      let submoduloRef = []
      if (path[3]) submodulo = path[3]
      if (path[4]) submoduloRef.push(path[4])

      /*console.log('submoduloRef', submoduloRef)
      console.log('submodulo', submodulo)
      console.log('moduloRef', moduloRef)
      console.log('modulo', modulo)*/

      params = {
        modulo: modulo,
        moduloRef: moduloRef,
        submodulo: submodulo,
        submoduloRef: submoduloRef,
      }

      if (params.moduloRef) {
        const res = await this.$axios.get(
          `documentos?modulo=${params.modulo}&moduloRef=${params.moduloRef}&submodulo=${params.submodulo}&submoduloRef=${params.submoduloRef}`
        )
        if (res) commit('SET_DOCUMENTOS', res.data['hydra:member'])
        //if (res) console.log('res.data', res.data)
      }
      state.verGestorDocumental = true
    } else state.verGestorDocumental = false
    commit('ACTUALIZAR_EVIDENCIAS', false)
    return state.documentos
  },

  /**
   * Esta función permite obtener documentos de un módulo y submódulo customizado
   * como por ejemplo, las acciones correctivas de un PAC
   */
  async listCustom({ state, commit }, params) {
    commit('RESET_DOCUMENTOS_MODULO_EXTERNO')
    let documentos = []
    // for (let i=0; i < params.submoduloRef.length; i++) {
    //   const submoduloRef = params.submoduloRef[i]
    //   const res = await this.$axios.put(`documentos`, {
    //     modulo: params.modulo,
    //     moduloRef: params.moduloRef,
    //     submodulo: params.submodulo,
    //     submoduloRef: submoduloRef
    //   })
    //   if (res) documentos = documentos.concat(res.data)
    // }
    let submoduloRef = []
    if (Array.isArray(params.submoduloRef)) {
      submoduloRef = params.submoduloRef
    } else if (params.submoduloRef) {
      submoduloRef = [params.submoduloRef]
    }

    await this.$axios
      .get(
        `documentos?modulo=${params.modulo}&moduloRef=${params.moduloRef}&submodulo=${params.submodulo}&submoduloRef=${submoduloRef}`
      )
      .then((res) => {
        documentos = documentos.concat(res.data['hydra:member'])
        commit('SET_DOCUMENTOS_MODULO_EXTERNO', documentos)
        return documentos
      })
  },

  /**
   * listCustomBySubmoduloRefs()
   * Igual que listCustom, pero serializa arrays como submoduloRef[].
   * Úsalo cuando el backend espera múltiples submoduloRef por parámetros repetidos.
   */
  async listCustomBySubmoduloRefs({ commit }, params) {
    commit('RESET_DOCUMENTOS_MODULO_EXTERNO')
    let documentos = []

    const query = new URLSearchParams()
    query.append('modulo', params.modulo)
    query.append('moduloRef', params.moduloRef)
    query.append('submodulo', params.submodulo)

    if (Array.isArray(params.submoduloRef)) {
      params.submoduloRef.filter(Boolean).forEach((ref) => {
        query.append('submoduloRef[]', ref)
      })
    } else if (params.submoduloRef) {
      query.append('submoduloRef', params.submoduloRef)
    }

    const res = await this.$axios.get(`documentos?${query.toString()}`)
    if (res) {
      documentos = documentos.concat(res.data['hydra:member'])
      commit('SET_DOCUMENTOS_MODULO_EXTERNO', documentos)
    }
    return documentos
  },

  // async visualize({rootState}, params_uuid) {
  //   const res = await this.$axios.get(`documentos/getOne/${params_uuid}`)
  //   if (res) return res.data
  // },

  async download({ rootState }, doc) {
    let href = `/public/documentos/${doc.uuid}`
    if (doc.contentUrl) href = doc.contentUrl
    this.$axios({
      method: 'GET',
      url: href,
      responseType: 'blob',
    })
      .then((response) => {
        const blob = new Blob([response.data], { type: response.data.type })
        const url = window.URL.createObjectURL(blob)
        const link = document.createElement('a')
        link.href = url
        const contentDisposition = getParameterCaseInsensitive(
          response.headers,
          'Content-Disposition'
        )
        let fileName = href.substring(href.lastIndexOf('/') + 1)
        if (contentDisposition) {
          const fileNameMatch = contentDisposition.match(/filename="(.+)"/)
          if (fileNameMatch != null && fileNameMatch.length === 2) fileName = fileNameMatch[1]
        }
        link.setAttribute('download', fileName)
        document.body.appendChild(link)
        link.click()
        link.remove()
        window.URL.revokeObjectURL(url)
      })
      .catch((e) => {
        throw e
      })
      .finally(() => {})
  },

  async create({ rootState, state }, data) {
    rootState.loading = true
    let path = data.path.split('/')
    let modulo = path[1]
    let moduloRef = path[2]
    // TODO DESARROLLO: MEJORAR LAS RUTAS DE AUDITORIA PARA PODER MANTENER ESTO DINAMICO
    if (moduloRef === 'tabs') {
      const modulo_uuid = data.fullPath.split('uuid=')
      moduloRef = modulo_uuid[1]
    }
    // TODO DESARROLLO: MEJORAR LAS RUTAS DE AUDITORIA PARA PODER MANTENER ESTO DINAMICO
    let submodulo = ''
    let submoduloRef = ''
    if (path[3]) submodulo = path[3]
    if (path[4]) submoduloRef = path[4]

    let datos = new FormData()
    datos.append('uuid', uuid.v4())
    datos.append('file', data.documento.file)
    datos.append('titulo', data.documento.titulo)
    datos.append('modulo', modulo)
    datos.append('moduloRef', moduloRef)
    datos.append('submodulo', submodulo)
    datos.append('submoduloRef', submoduloRef)

    if (state.external_ref) datos.append('external_ref', state.external_ref)

    await this.$axios.post('documentos', datos)

    rootState.loading = false

    if (state.external_ref) state.external_ref = null
  },

  /**
   * Esta función permite añadir documentos de un módulo y submódulo customizado
   * como por ejemplo, las acciones correctivas de un PAC
   */

  async addCustom({ rootState, state, dispatch, commit }) {
    const documentos_custom = state.documentos_custom
    if (documentos_custom && documentos_custom.length > 0) {
      for (let i = 0; i < documentos_custom.length; i++) {
        const documento = documentos_custom[i]
        await dispatch('createCustom', documento)
      }
      commit('INIT_CUSTOM')
    }
  },

  async createCustom({ rootState, state, commit }, data) {
    rootState.loading = true
    const dataUuid = data.uuid ? data.uuid : uuid.v4()
    let datos = new FormData()

    // 🔑 Soporte para ambas estructuras
    const file = data.documento ? data.documento.file : data.file
    const titulo = data.documento ? data.documento.titulo : data.titulo

    if (!file) {
      console.error('❌ createCustom recibió un documento sin archivo:', data)
      rootState.loading = false
      return
    }

    datos.append('uuid', dataUuid)
    datos.append('archivoDocumento', file)
    datos.append('titulo', titulo)
    datos.append('modulo', data.modulo)
    datos.append('moduloRef', data.moduloRef)
    datos.append('submodulo', data.submodulo)
    datos.append('submoduloRef', data.submoduloRef)

    if (data.external_ref) datos.append('externalRef', data.external_ref)

    try {
      const res = await this.$axios.post('documentos', datos)

      if (res && res.data) {
        // 🔄 Reemplazamos el documento en documentos_modulo_externo
        state.documentos_modulo_externo = state.documentos_modulo_externo.filter(
          (d) => d.uuid && d.uuid !== dataUuid
        )
        commit('SET_DOCUMENTOS_MODULO_EXTERNO', [res.data])
      }
    } catch (e) {
      console.error('❌ Error creando documento:', e)
    } finally {
      rootState.loading = false
    }
  },
  async delete({ rootState, commit }, params_uuid) {
    rootState.loading = true
    try {
      await this.$axios.delete(`documentos/${params_uuid}`)
      commit('ACTUALIZAR_EVIDENCIAS', true)
    } catch (e) {
      console.info(e)
    } finally {
      rootState.loading = false
    }
  },
}
